/** Classi badge per tipo contenuto (lista + calendario). */
export const CONTENT_TYPE_BADGE = {
  post: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-600/35 dark:text-indigo-200',
  story: 'bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-900/35 dark:text-fuchsia-200',
  reel: 'bg-violet-100 text-violet-800 dark:bg-violet-900/35 dark:text-violet-200',
};

export function contentTypeBadgeClass(contentType) {
  return CONTENT_TYPE_BADGE[contentType] || CONTENT_TYPE_BADGE.post;
}

export function contentTypeI18nKey(contentType) {
  return `gym.social.posts.types.${contentType || 'post'}`;
}
